import React from 'react';
import styled from 'styled-components';

const ImageComponent = ({
  src,
  height,
  width,
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => (
  <ImageWrap>
    <img className="menu-img" alt="" src={src} height={height} width={width} {...props} />
  </ImageWrap>
);

export default ImageComponent;

const ImageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
